// src/pages/ConsentPage/consentApi.js
import api from '../../services/api';

export const getConsentText = (version) => api.get('/consent/text', { params: version ? { version } : {} });
export const getConsentForCase = (caseId) => api.get(`/consent/case/${caseId}`);
export const getConsentState = (childId) => api.get(`/consent/state/${childId}`);
export const saveConsent = (caseId, body) => api.post(`/consent/case/${caseId}`, body);
export const markCopyDelivered = (consentId, channel) => api.post(`/consent/${consentId}/copy-delivered`, { channel });
export const requestWithdrawal = (consentId, reason) => api.post(`/consent/${consentId}/withdrawal-request`, { reason });
// Staff-wide, not therapist-only: the intake worker needs to see that the
// request she raised is still waiting, so she does not raise a second one.
export const listPendingWithdrawals = () => api.get('/consent/withdrawal-requests?status=pending');

// A short, non-identifying note of what captured the consent.
export function deviceFingerprint() {
    const screen = `${window.screen?.width || 0}x${window.screen?.height || 0}`;
    return `${navigator.platform || 'unknown'} · ${screen} · ${navigator.language || ''}`.trim();
}

export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';
